(function () {
  "use strict";

  // Observer padrão — fade + slide up
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  // Aplicar observer em todos os elementos animáveis
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  // Observer para grids com stagger
  const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const cards = entry.target.querySelectorAll('.reveal-card');
        cards.forEach((card, i) => {
          setTimeout(() => card.classList.add('is-visible'), i * 100);
        });
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal-grid').forEach(el => staggerObserver.observe(el));

  // Contadores
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el     = entry.target;
      const target = parseInt(el.dataset.valor || el.dataset.count || 0, 10);
      const sufixo = el.dataset.sufixo || '';
      if (!target) return;

      const duration = 1800;
      const start    = performance.now();

      function update(now) {
        const elapsed  = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased    = 1 - Math.pow(1 - progress, 3); // ease out cubic
        el.textContent = Math.round(target * eased) + sufixo;
        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
      counterObserver.unobserve(el);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.contador-num').forEach(el => counterObserver.observe(el));

})();
